export const STRINGS = {
  PAGE_TITLE: 'DeHaat | Farmbook',
  PAGE_DESCRIPTION:
    'DeHaat connects farmers to suppliers and buyers on a single platform. Online marketplace providing all the agricultural products and services to farmers.',
  FARMBOOK: 'Farmbook',
  DEHAAT_WALL: 'DeHaat Wall',
  TWITTER: 'Twitter',
  VIDEOS: 'Videos',
  TWEETS: 'Loading tweets by DeHaatTM...',
  PREVIOUS: 'Previous',
  NEXT: 'Next',
}

export enum PAGE_TYPE {
  DEHAAT_WALL,
  TWITTER,
  VIDEOS,
}

export const PAGES = [
  {
    label: STRINGS.DEHAAT_WALL,
    link: '/farmbook',
    type: PAGE_TYPE.DEHAAT_WALL,
  },
  {
    label: STRINGS.TWITTER,
    link: '/farmbook/twitter',
    type: PAGE_TYPE.TWITTER,
  },
  {
    label: STRINGS.VIDEOS,
    link: '/farmbook/videos',
    type: PAGE_TYPE.VIDEOS,
  },
]
